<template>
    <div class="mx-auto max-w-7xl space-y-6 sm:px-6 lg:px-8">
        <div :class="{'bg-red-100 border border-red-400 text-red-700': red, 'bg-white': !red}" class="p-4 shadow sm:rounded-lg sm:p-4">
            <section :class="{'max-w-xl': limitedWidth, 'grid grid-cols-1 lg:grid-cols-2 gap-x-4 w-full': twoColumns}">
                <slot></slot>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        limitedWidth: {
            type: Boolean,
            default: true
        },
        red: {
            type: Boolean,
            default: false
        },
        twoColumns: {
            type: Boolean,
            default: false
        }
    }
}
</script>